import React from 'react';
import { StepProps } from '../../types/form';
import { DOCUMENT_CAPABILITIES } from '../../data/referenceData';
import { useReferenceData } from '../../context/ReferenceDataContext';
import { FormField } from '../ui/FormField';
import { SelectDropdown } from '../ui/SelectDropdown';
import { OptionMultiSelect } from '../ui/OptionMultiSelect';
export function DocumentsStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  const {
    documentTags,
    documentServices,
    isLoading
  } = useReferenceData();
  const toggleCapability = (key: (typeof DOCUMENT_CAPABILITIES)[number]['key']) => {
    const current = formData.documentCapabilities;
    updateFormData({
      documentCapabilities: current.includes(key) ? current.filter(c => c !== key) : [...current, key]
    });
  };
  return <div className="space-y-6" data-id="element-66">
      <div data-id="element-67">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-68">Documents</h2>
        <p className="text-sm text-muted-foreground" data-id="element-69">
          What document access and limits should users in this group have?
        </p>
      </div>

      <FormField id="documentTemplateTagIds" label="Which document templates should they access?" required error={errors.documentTemplateTagIds} data-id="element-70">
        <OptionMultiSelect options={documentTags} selectedValues={formData.documentTemplateTagIds} onChange={vals => updateFormData({
        documentTemplateTagIds: vals
      })} allSelected={formData.documentAllTags} onSelectAll={all => updateFormData({
        documentAllTags: all,
        documentTemplateTagIds: []
      })} placeholder="Select templates..." error={!!errors.documentTemplateTagIds} loading={isLoading} data-id="element-71" />
      </FormField>

      <FormField id="documentServiceIds" label="Which document types or services?" required error={errors.documentServiceIds} data-id="element-72">
        <OptionMultiSelect options={documentServices} selectedValues={formData.documentServiceIds} onChange={vals => updateFormData({
        documentServiceIds: vals
      })} allSelected={formData.documentAllServices} onSelectAll={all => updateFormData({
        documentAllServices: all,
        documentServiceIds: []
      })} placeholder="Select services..." error={!!errors.documentServiceIds} loading={isLoading} data-id="element-73" />
      </FormField>

      <FormField id="documentCapabilities" label="Which document capabilities should they have?" required error={errors.documentCapabilities} data-id="element-74">
        <div className="space-y-3 mt-2 bg-muted/30 p-4 rounded-md border border-border" data-id="element-75">
          {DOCUMENT_CAPABILITIES.map(cap => <label key={cap.key} className="flex items-start space-x-3 cursor-pointer" data-id="element-76">
              <input type="checkbox" checked={formData.documentCapabilities.includes(cap.key)} onChange={() => toggleCapability(cap.key)} className="mt-1 h-4 w-4 rounded border-input text-primary focus:ring-ring" data-id="element-77" />
              <span className="text-sm text-foreground" data-id="element-78">{cap.label}</span>
            </label>)}
        </div>
      </FormField>

      <div className="pt-4 border-t border-border space-y-4" data-id="element-79">
        <h3 className="text-sm font-medium text-foreground" data-id="element-80">Limits (Optional)</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-81">
          {[{
          id: 'docsPerMonth',
          label: 'Documents Per Month (Per User)',
          field: 'docsPerMonth' as const
        }, {
          id: 'docsInProgress',
          label: 'Documents In Progress at Once',
          field: 'docsInProgress' as const
        }, {
          id: 'maxPagesPerReview',
          label: 'Max Pages Per Document Review',
          field: 'maxPagesPerReview' as const
        }, {
          id: 'monthlyShares',
          label: 'Monthly Document Shares',
          field: 'monthlyShares' as const
        }, {
          id: 'monthlyDownloads',
          label: 'Monthly Document Downloads',
          field: 'monthlyDownloads' as const
        }, {
          id: 'monthlyReviews',
          label: 'Monthly Document Reviews',
          field: 'monthlyReviews' as const
        }].map(({
          id,
          label,
          field
        }) => <FormField key={id} id={id} label={label} data-id="element-82">
              <SelectDropdown id={id} value={formData[field] === '' ? 'unlimited' : String(formData[field])} onChange={val => updateFormData({
            [field]: val === 'unlimited' ? '' : parseInt(val as string, 10)
          })} options={[{
            label: 'Unlimited',
            value: 'unlimited'
          }, {
            label: '5',
            value: '5'
          }, {
            label: '10',
            value: '10'
          }, {
            label: '20',
            value: '20'
          }, {
            label: '50',
            value: '50'
          }, {
            label: '100',
            value: '100'
          }]} data-id="element-83" />
            </FormField>)}
        </div>
      </div>
    </div>;
}